import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { key: 0 }

type Props = {
  presentDetails: boolean
  header: string[]
  rows: any[][]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'KPICardFooter',
  props: {
    presentDetails: { type: Boolean },
    header: {},
    rows: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.presentDetails)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.header, (h, i) => {
              return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(h), 1))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                return (_openBlock(), _createElementBlock("td", { key: cell }, _toDisplayString(cell), 1))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})